<template>
  <gmap-map :center="center" :zoom="zoom">
    <tk-custom-marker
      v-for="(m, index) in mapItems"
      :key="index"
      :position="m.position"
      :price="m.price"
      :clicking="selectedClicks[index]"
      @click="clickMarker(m, index)"
    />
  </gmap-map>
</template>

<script>
import TkCustomMarker from './TkCustomMarker.vue'

export default {
  name: 'TkHotelListMap',
  components: { TkCustomMarker },
  props: {
    zoom: {
      type: Number,
      default: 12,
    },
    items: {
      type: Array,
      required: true,
    },
    center: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedClicks: Array(this.items.length).fill(false),
    }
  },
  computed: {
    mapItems() {
      return this.items.map((it) => ({
        id: it.id,
        position: {
          lat: it.lat,
          lng: it.lng,
        },
        price: it.price,
      }))
    },
  },
  methods: {
    clickMarker(item, index) {
      const temp = Array(this.items.length).fill(false)
      temp[index] = true
      this.selectedClicks = temp
      this.$emit('selected', item)
    },
  },
}
</script>
